import { SpherePlatformApp } from '@sphere/platform';
import { symbolSearchApp } from './symbol-search';
import { PATHS } from './symbol-search.paths';

export const SymbolSearchApp: SpherePlatformApp = {
    APP: symbolSearchApp,
    PATHS
};
